import { actionType } from "../utils/helpers/generalHelper";
import * as DeliveryConstants from "../constants/delivery.constant";
import DeliveryService from "../services/delivery.service";
import ErrorHelper from "../utils/helpers/errorHelper";
import { toast } from "react-hot-toast";

export const createDeliveryFee = (payload, reload) => async (dispatch) => {
  try {
    dispatch(actionType(DeliveryConstants.ADD_DELIVERY_FEE_REQUEST));
    const data = await DeliveryService.create(payload);
    if (data.status !== 201) {
      throw data;
    }
    const responseData = data.data;
    dispatch(
      actionType(DeliveryConstants.ADD_DELIVERY_FEE_SUCCESS, responseData)
    );
    reload();
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(DeliveryConstants.ADD_DELIVERY_FEE_FAILURE));
    toast.error(message);
  }
};

export const updateDeliveryFee = (id, payload, reload) => async (dispatch) => {
  try {
    dispatch(actionType(DeliveryConstants.UPDATE_DELIVERY_FEE_REQUEST));
    const data = await DeliveryService.updateDeliveryStation(id, payload);
    if (data.status !== 200) {
      throw data;
    }
    const responseData = data.data;
    dispatch(
      actionType(DeliveryConstants.UPDATE_DELIVERY_FEE_SUCCESS, responseData)
    );
    toast.success("Delivery fee updated successfully");
    reload();
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(DeliveryConstants.UPDATE_DELIVERY_FEE_FAILURE));
    toast.error(message);
  }
};

export const fetchDeliveryFees = (pageAble) => async (dispatch) => {
  try {
    dispatch(actionType(DeliveryConstants.GET_ALL_DELIVERY_FEE_REQUEST));
    const data = await DeliveryService.getDeliveryFees(pageAble);
    if (data.status !== 200) {
      throw data;
    }
    const responseData = data.data;
    dispatch(
      actionType(DeliveryConstants.GET_ALL_DELIVERY_FEE_SUCCESS, responseData)
    );
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(DeliveryConstants.GET_ALL_DELIVERY_FEE_FAILURE));
    toast.error(message);
  }
};

export const fetchDeliveryStations = () => async (dispatch) => {
  try {
    dispatch(actionType(DeliveryConstants.GET_DELIVERY_STATIONS_REQUEST));
    const data = await DeliveryService.getStationNames();
    if (data.status !== 200) {
      throw data;
    }
    const responseData = data.data;
    dispatch(
      actionType(DeliveryConstants.GET_DELIVERY_STATIONS_SUCCESS, responseData)
    );
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(DeliveryConstants.GET_DELIVERY_STATIONS_FAILURE));
    toast.error(message);
  }
};

export const deleteDeliveryFee = (id) => async (dispatch) => {
  try {
    dispatch(actionType(DeliveryConstants.DELETE_DELIVERY_FEE_REQUEST, {
      loading: true,
      id,
    }));
    const data = await DeliveryService.deleteDeliveryStation(id);
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    dispatch(
      actionType(DeliveryConstants.DELETE_DELIVERY_FEE_SUCCESS, {
        loading: false,
        id,
      })
    );
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(DeliveryConstants.DELETE_DELIVERY_FEE_FAILURE, {
      loading: false,
      id,
    }));
    toast.error(message);
  }
};
